import { useState } from 'react'

import DistributorsApi, { DistributorsKey } from '@services/distributors.api'
import { useInfiniteQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import TreeInputDialogUI from '../components/TreeInputDialogUI'
import { useTreeInput } from '../RHFTreeInputProvider'

export default function DistributorTreeInputDialog() {
	const context = useTreeInput()
	const [searchTerm, setSearchTerm] = useState('')

	const { data, isLoading, isRefetching, isFetchingNextPage, fetchNextPage, hasNextPage, error } =
		useInfiniteQuery({
			queryKey: DistributorsKey.search({ searchTerm }),
			queryFn: ({ pageParam }) =>
				DistributorsApi.search({ searchTerm, page: pageParam, pageSize: 50 }),
			enabled: searchTerm.length > 1,
			initialPageParam: 1,
			getNextPageParam: (lastPage) => {
				const { page, totalPages } = lastPage.pagination
				return page < totalPages ? page + 1 : null
			},
			throwOnError: false,
		})

	const results = data?.pages.flatMap((page) => page.data) ?? null
	const errorMessage = error ? (error as AxiosError<ApiErrorRes>).response?.data?.message : null

	const getPrimaryText = (item: CategorySearchResult) => item.name
	const getSecondaryText = () => null
	const getPrimaryCaption = (item: CategorySearchResult) => item.parentName || null
	const getSecondaryCaption = (item: CategorySearchResult) => `PLID: ${item.plid || ''}`

	return (
		<TreeInputDialogUI
			{...context}
			category="distributors"
			searchTerm={searchTerm}
			setSearchTerm={setSearchTerm}
			errorMessage={errorMessage}
			results={results}
			isLoading={isLoading}
			isRefetching={isRefetching}
			isFetchingNextPage={isFetchingNextPage}
			fetchNextPage={fetchNextPage}
			hasNextPage={hasNextPage}
			inputTip="Tip: You can search by the distributor name or PLID."
			getPrimaryText={getPrimaryText}
			getSecondaryText={getSecondaryText}
			getPrimaryCaption={getPrimaryCaption}
			getSecondaryCaption={getSecondaryCaption}
		/>
	)
}
